import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Skeleton from '../../common/skeleton';
import './CompareResultsCard.scss';

const CompareResultsCard = () => {
  return (
    <Card className="provider-details-card price-compare-result-page-skeleton mb-5">
      <Row className="profile-primary-info  align-items-center justify-content-between">
        <Col md={6} xs={12}>
          <Row className="align-items-center">
            <Col md={2} xs={12} className="m-0 p-0">
              <Skeleton
                height={70}
                width={70}
                count={1}
                circle={true}
                containerClassName={'skeleton-image-circle'}
              />
            </Col>
            <Col md={5} xs={12} className="p-0 m-0">
              <Skeleton
                height={12}
                count={2}
                containerClassName={'name-address-info'}
              />
            </Col>
          </Row>
        </Col>
        <Col md={6} xs={12}>
          <div className="text-right">
            <Skeleton
              height={24}
              width={100}
              count={1}
              containerClassName={'name-address-info'}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default CompareResultsCard;
